import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';

import { Chapter } from '../../../../models/chapter';
import { ChapterService } from '../../../../services/chapter.service';
import { Note } from '../../../../models/note';
import { SidebarSingleNoteComponent } from '../sidebar-single-note/sidebar-single-note.component';

@Component({
    selector: 'sidebar-mainchapter-notes',
    templateUrl: './sidebar-mainchapter-notes.component.html',
    styleUrls: ['./sidebar-mainchapter-notes.component.scss'],
    standalone: true,
    imports: [
        SidebarSingleNoteComponent
    ]
})
export class SidebarMainchapterNotesComponent implements OnInit {

    @Input() mainChapterNotes: { chapter: Chapter; notes: Array<Note> };

    notesBeforeFirstSubChapter: Array<Note> = [];
    chapterNotes: Array<{ chapter: Chapter; notes: Array<Note> }>;
    hierarchyMap: Map<number, Array<string | number>>;

    private lowestSubChapterIndex: number = Number.MAX_VALUE;

    constructor(private chapterService: ChapterService) {
    }

    ngOnInit(): void {

        this.chapterNotes = [];
        // this.mainChapterNotes.chapter.subChapters.unshift(this.mainChapterNotes.chapter);
        this.hierarchyMap = new Map();
        this.getHierarchy();

        this.chapterService.getMainChapterStartAndEndIndex(this.mainChapterNotes.chapter).then(indizes => {

            for (let pos = 0; pos < this.mainChapterNotes.chapter.subChapters.length; pos++) {

                const startIndex = this.getStartIndex(pos);
                const endIndex = this.getEndIndex(this.mainChapterNotes.chapter.subChapters, pos, indizes[1]);

                if (startIndex < this.lowestSubChapterIndex) {
                    this.lowestSubChapterIndex = startIndex;
                }

                let notesInChapter = _.filter(this.mainChapterNotes.notes, note => {
                    return note.index >= startIndex && note.index < endIndex;
                });

                notesInChapter = _.sortBy(notesInChapter, ele => {
                    return ele.index;
                });

                this.chapterNotes.push(
                    {
                        chapter: this.mainChapterNotes.chapter.subChapters[pos],
                        notes: notesInChapter
                    });
            }

            this.mainChapterNotes.notes.forEach(note => {
                if (note.index < this.lowestSubChapterIndex) {
                    this.notesBeforeFirstSubChapter.push(note);
                }
            });

        });
    }

    private getHierarchy(): void {

        this.mainChapterNotes.chapter.subChapters.forEach(subChapter => {

            this.chapterService.getChapterHierarchyFromChapter(subChapter).then(hierarchy => {

                this.hierarchyMap.set(subChapter.id, hierarchy);
            });
        });
    }

    private getStartIndex(indexOfSubchapter: number): number {
        return this.mainChapterNotes.chapter.subChapters[indexOfSubchapter].index;
    }

    private getEndIndex(subchapters: Array<Chapter>, indexOfSubchapter: number, maxIndex: number): number {
        let endIndex;

        if (this.mainChapterNotes.chapter.subChapters[indexOfSubchapter + 1]) {

            endIndex = this.mainChapterNotes.chapter.subChapters[indexOfSubchapter + 1].index;

        } else {

            endIndex = maxIndex;

        }

        return endIndex;
    }

}
